import { Button } from '@mui/material';
import { TOrganisationCodeWorkflowType } from '../OrganisationCodeWorkflowSwitcher/OrganisationCodeWorkflowSwitcher';

export interface WorkflowButtonProps {
  workflow: TOrganisationCodeWorkflowType;
  isSelected: boolean;
  label: string;
  onClick: (workflow: TOrganisationCodeWorkflowType) => void;
  disabled?: boolean;
  dataTestId?: string;
}

export function WorkflowButton({
  workflow,
  isSelected,
  label,
  onClick,
  disabled = false,
  dataTestId,
}: Readonly<WorkflowButtonProps>) {
  return (
    <Button
      variant={isSelected ? 'contained' : 'outlined'}
      onClick={() => onClick(workflow)}
      disabled={disabled}
      aria-pressed={isSelected}
      data-testid={dataTestId}
      sx={(theme) => ({
        flex: 1,
        minWidth: 0,
        py: theme.semantic.spacing.sm,
        px: theme.semantic.spacing.xs,
        fontSize: theme.semantic.fontSize.xs,
        fontWeight: isSelected ? theme.semantic.fontWeight.bold : theme.semantic.fontWeight.regular,
        ...(isSelected && {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        }),
      })}
      data-action={`workflow-${workflow.toLowerCase()}`}
    >
      {label}
    </Button>
  );
}
